import { exportExcel } from "../services/exportExcel"
import { useError } from "../contexts/ErrorContext"
import { useLoading } from "../contexts/LoadingContext"
/**
 * Hook that provides a function for exporting data as an excel sheet
 * 
 * @returns {function} handleExportToExcel - function requests excel data from API, creates browser link for user to download file
 * 
 * @category Hooks
 */
export const useExportExcel = () => {
    const {showError} = useError()
    const {showLoading, hideLoading} = useLoading()
    /**
     * function to send JSON data to API to convert to excel
     * 
     * @param {Object[]} data 
     * @param {Object} columnNameMap maps database names to column titles, backend uses this to format excel column titles to what Martrak is expecting. For example, "Site_Name" (from db) is mapped to "Site Name"
     * @param {string} route api route to call
     * 
     * @returns {blob} excel file as blob, downloadable in the browser
     */
    const handleExportToExcel = async(data, columnNameMap, route, jobName, JobID) => {
        try {
            showLoading(`Exporting ${route}`)
            const response = await exportExcel(data, columnNameMap, route, JobID);

            if(response?.errorType) {
              throw new Error(response.message)
            }
            // create url for user to download excel file
            const url = window.URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${route}_${jobName}.xlsx`);
            document.body.appendChild(link);
            link.click();
        
            // remove link after download
            link.remove();
            window.URL.revokeObjectURL(url);

          } catch (error) {
            showError(`There was a problem exporting the file: ${error.message}`)
          }
          finally{
            hideLoading()
          }
    }

    return { handleExportToExcel }
}